export default {
  data () {
    return {
      errors: []
    }
  },
  methods: {
    getResponseErrors (res) {
      var errors = []
      if (res.status === 422) {
        if (res.data) {
          for (var i in res.data) {
            for (var e in res.data[i]) {
              errors.push(res.data[i][e])
            }
          }
        }
      }
      return errors
    },
    joinErrorsToMsg (errors) {
      let msg = ''
      for (var e in errors) {
        msg = msg + errors[e] + '. '
      }
      return msg
    }
  },
  dismissErrors () {
    this.errors = []
  }
}



// WEBPACK FOOTER //
// ./src/mixins/FormErrors.js